import { Col, Container, Row } from "react-bootstrap";
import { House, People, CreditCard } from "react-bootstrap-icons";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";
import { PageTitle } from "../../Controls/PageTitle";
import { Operator } from "../../Data/ApiTypes";
import { MenuItem } from "../../Controls/MenuItem";

export function AppAdmin() {
    const loc      = useLocation();
    const operator = useLoaderData() as Operator;

    //for handling mobile and desktop versions of these pages
    const [menuClassName, contentClassName] = loc.pathname === ( `/admin` ) ? ["", "d-none"] : ["d-none", ""];
    const activeOverride = loc.pathname === ( `/admin` ) ? true : false;

    return <Container fluid className="fullheight pt-2">
        <Row className="fullheight">
            <Col md={5} lg={5} xl={4} xxl={3} id="facility-menu" className={`${menuClassName} d-md-grid fullheight scroll-y-auto border-end`}>
                <div className="facility-menu-item fw-bold">
                    <PageTitle className="grid-col-span-5 text-center align-self-center fw-bold">
                        SpotSync Admin
                    </PageTitle>
                </div>
                {/* <MenuItem default icon={<House      />} to="./overview"           text="Overview"           />                 */}
                <MenuItem active={activeOverride} default icon={<People      />} to="./operators" text="Operators"/>                
                <MenuItem                                 icon={<CreditCard  />} to="./fees" text="Fees" />
                <MenuItem  default icon={<People      />} to="./users" text="Super Admins"/>                                            
            </Col>
            <Col md={7} lg={7} xl={8} xxl={9} className={`${contentClassName} p-0 m-0 d-md-block fullheight scroll-y-auto`}>
                <Outlet />
            </Col>
        </Row>
    </Container>;
}